export default (context, ele) => {
    const value = !context.state.handleOther;
    const moduleId = context.getters.moduleId;
    let trackedErrors = [
        `LniRetaliationCertify_certify`,
        `LniRetaliationForm_complaint_complaint`,
        `LniRetaliationForm_complaint_explanation_input-text`,
        `LniRetaliationForm_complaint_other-allegation`,
        `LniRetaliationForm_contact_first-name`,
        `LniRetaliationForm_contact_last-name`,
        `LniRetaliationForm_contact_email-address`,
        `LniRetaliationForm_contact_phone-number`,
        `LniRetaliationForm_contact_position-title`,
        `LniRetaliationForm_contact_user-language`,
        `LniRetaliationForm_employer_employer-list`,
    ];
    const setAttribute = function(context, id, attribute, value) {
        context.commit('setAttribute', {
            id,
            attribute,
            value,
        }, {
            root: true,
        });
    };
    if (ele) {
        context.dispatch(`clearEmployer`, {
            root: true,
        }).then(() => {
            setAttribute(context, `LniRetaliationForm_contact_address_county`, 'options', context.rootState.appState.counties);
            setAttribute(context, `${moduleId}`, 'handleOther', value);
            if (ele.tab.innerText === 'ADD NEW EMPLOYER') {
                trackedErrors = [
                    `LniRetaliationCertify_certify`,
                    `LniRetaliationForm_complaint_complaint`,
                    `LniRetaliationForm_complaint_explanation_input-text`,
                    `LniRetaliationForm_complaint_other-allegation`,
                    `LniRetaliationForm_contact_first-name`,
                    `LniRetaliationForm_contact_last-name`,
                    `LniRetaliationForm_contact_email-address`,
                    `LniRetaliationForm_contact_phone-number`,
                    `LniRetaliationForm_contact_position-title`,
                    `LniRetaliationForm_contact_user-language`,
                    `LniRetaliationForm_employer_name`,
                    `LniRetaliationForm_employer_email-address`,
                    `LniRetaliationForm_employer_phone-number_phone`,
                ];
                setAttribute(context, `appState`, 'trackedErrors', trackedErrors);
                setAttribute(context, `${moduleId}_employer-list`, 'required', false);
                setAttribute(context, `${moduleId}_name`, 'required', true);
                setAttribute(context, `${moduleId}_phone-number_phone`, 'required', true);
                setAttribute(context, `${moduleId}_email-address_input-text`, 'required', true);
            } else if (ele.tab.innerText === 'SEARCH ESTABLISHMENTS') {
                trackedErrors = [
                    `LniRetaliationCertify_certify`,
                    `LniRetaliationForm_complaint_complaint`,
                    `LniRetaliationForm_complaint_explanation_input-text`,
                    `LniRetaliationForm_complaint_other-allegation`,
                    `LniRetaliationForm_contact_first-name`,
                    `LniRetaliationForm_contact_last-name`,
                    `LniRetaliationForm_contact_email-address`,
                    `LniRetaliationForm_contact_phone-number`,
                    `LniRetaliationForm_contact_position-title`,
                    `LniRetaliationForm_contact_user-language`,
                    `LniRetaliationForm_employer_employer-list`,
                ];
                setAttribute(context, `appState`, 'trackedErrors', '');
                setAttribute(context, `${moduleId}_employer-list`, 'required', true);
                setAttribute(context, `${moduleId}_name`, 'required', false);
                setAttribute(context, `${moduleId}_phone-number_phone`, 'required', false);
                setAttribute(context, `${moduleId}_email-address_input-text`, 'required', false);
            }
            setAttribute(context, `appState`, 'trackedErrors', trackedErrors);
            setAttribute(context, `LniRetaliationForm_error-container`, 'errorsCollectedFrom', trackedErrors);
        });
    }
};